import { CLOSE_NOTIFY, OPEN_NOTIFY } from './types';

export function openNotify(options) {
  return {
    type: OPEN_NOTIFY,
    options,
  };
}

export function closeNotify() {
  return { type: CLOSE_NOTIFY };
}
